import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import type { Image3D } from '~/domain/patient/image3d';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import { useActiveFusionTarget } from '~/hooks/target/useActiveFusionTarget';
import { usePrimaryRowPairView } from '~/hooks/usePrimaryRowPairView';
import { referenceComparisonState } from '~/state/atoms/viewportGridAtoms';

// The images shown on their own beside the primary image: the pair drawn apart, and the reference row.
export function useComparisonImages(): ReadonlyArray<Image3D> {
    const patient = useSelectedPatient();
    const { secondaryImage } = useActiveFusionTarget();
    const { apart } = usePrimaryRowPairView();
    const reference = useRecoilValue(referenceComparisonState);
    const referenceImage = patient?.images.find(
        (image) => image.seriesUid === reference?.seriesUid
    );
    const paired = apart ? secondaryImage : undefined;
    return useMemo(
        () =>
            [paired, referenceImage].filter(
                (image): image is Image3D => image !== undefined
            ),
        [paired, referenceImage]
    );
}
